const mrrScale = [
  {
    value: 0,
    scaledValue: 10000,
    label: '10k'
  },
  {
    value: 25,
    scaledValue: 15000,
    label: '15k'
  },
  {
    value: 50,
    scaledValue: 25000,
    label: '25k'
  },
  {
    value: 75,
    scaledValue: 75000,
    label: '75k'
  },
  {
    value: 100,
    scaledValue: 100000,
    label: '100k'
  },
  {
    value: 125,
    scaledValue: 150000,
    label: '150k'
  },
  {
    value: 150,
    scaledValue: 250000,
    label: '250k'
  },
  {
    value: 175,
    scaledValue: 500000,
    label: '500k'
  },
  {
    value: 200,
    scaledValue: 1000000,
    label: '1M'
  }
]

const meScale = [
  {
    value: 0,
    scaledValue: 10000,
    label: '10k'
  },
  {
    value: 15,
    scaledValue: 15000,
    label: '15k'
  },
  {
    value: 25,
    scaledValue: 25000,
    label: '25k'
  },
  {
    value: 100,
    scaledValue: 100000,
    label: '100k'
  },
  {
    value: 130,
    scaledValue: 250000,
    label: '250k'
  },
  {
    value: 155,
    scaledValue: 500000,
    label: '500k'
  },
  {
    value: 175,
    scaledValue: 1000000,
    label: '1M'
  },
  {
    value: 200,
    scaledValue: 1500000,
    label: '1.5M'
  },
  {
    value: 240,
    scaledValue: 2000000,
    label: '2M'
  }
]

const momScale = [
  {
    value: 0,
    scaledValue: 0,
    label: '0.0'
  },
  {
    value: 500,
    scaledValue: 5,
    label: '5.0'
  },
  {
    value: 800,
    scaledValue: 8,
    label: '8.0'
  }
  // {
  //   value: 500,
  //   scaledValue: 20,
  //   label: '20.0'
  // }
]

const cbScale = [
  {
    value: 0,
    scaledValue: 50000,
    label: '50K'
  },
  {
    value: 450,
    scaledValue: 500000,
    label: '50K'
  },
  {
    value: 700,
    scaledValue: 1000000,
    label: '1.0M'
  },
  {
    value: 950,
    scaledValue: 2000000,
    label: '2.0M'
  },
  {
    value: 1250,
    scaledValue: 5000000,
    label: '5.0M'
  },
  {
    value: 1500,
    scaledValue: 10000000,
    label: '10.0M'
  }
]

export { mrrScale, meScale, momScale, cbScale }
